export default __webpack_public_path__ + "static/assets/med_pill_round_in_L0_solid_x_01_f_mask.30f4f0ab.png";